import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AccessibilitySlice } from "./types";

const initialState: AccessibilitySlice = {
	a11yIdsToDomIds: {}
};

export const {
	name: accessibilitySliceName,
	actions: { setA11yDomId },
	reducer: accessibilityReducer
} = createSlice({
	name: "accessibility",
	initialState,
	reducers: {
		setA11yDomId(state: AccessibilitySlice, action: PayloadAction<[string, string]>) {
			state.a11yIdsToDomIds[action.payload[0]] = action.payload[1];
		}
	}
});
